<template>
    <step-section
            :title="$t('sizeAndQuantity')"
            :loading="loading$"
            :step-number="getStepNumber('sizeAndQuantity')"
    >
        <form action="#" id="size-form">
            <div class="row row--custom relative-p">
                <div class="col-12 img-size">
                    <div class="step-block step-block--size">
                        <figure class="size-window-img" id="size-content">
                            <span class="corner-right"></span>
                            <span class="corner-bottom"></span>
                            <img
                                    class="img-fluid"
                                    :src="windowTypeImage"
                            >
                            <span class="size-vt" v-if="form.height">
                <span class="units">
                  {{ form.height }}
                </span>
              </span>
                            <span class="size-ht" v-if="form.width">
                <span class="units">
                  {{ form.width }}
                </span>
              </span>
                        </figure>
                    </div>
                </div>
                <div class="col-12 form-size">
                    <div class="step-block step-block--content-form">
                        <div class="step-block--form">
                            <div class="form-group" :class="{'validate-error': widthDirty && !isWidthValid}">
                                <label for="sizeWidth">
                                    {{ $t('width') }}
                                </label>
                                <input
                                        type="number"
                                        class="form-control"
                                        name="sizeWidth"
                                        :value="form.width"
                                        @input="handleWidthChange"
                                        @blur="handleWidthBlur"
                                >
                                <span class="units">mm</span>
                                <div class="valid-status">
                                    <span class="valid-ico check-icon check-icon--small"></span>
                                    <span class="valid-ico ico-cancle check-icon check-icon--small"></span>
                                </div>
                                <div class="value-size">
                  <span>
                    {{ $t('minMaxSize', { min:minWidth, max: maxWidth }) }}
                  </span>
                                </div>
                            </div>
                            <button type="button" class="form-btn" tabindex="-1">
                                <span class="icon icon-cross-remove-sign"></span>
                            </button>
                        </div>
                        <div class="step-block--form">
                            <div class="form-group" :class="{'validate-error': form.height && !isHeightValid}">
                                <label for="sizeHeight">
                                    {{ $t('height') }}
                                </label>
                                <input
                                        type="number"
                                        class="form-control"
                                        name="sizeHeight"
                                        :disabled="!isWidthValid"
                                        :value="form.height"
                                        @input="handleHeightChange"
                                >
                                <span class="units">mm</span>
                                <div class="valid-status">
                                    <span class="valid-ico check-icon check-icon--small"></span>
                                    <span class="valid-ico ico-cancle check-icon check-icon--small"></span>
                                </div>
                                <div class="value-size" v-if="currentRange">
                  <span>
                    {{ $t('minMaxSize', { min:currentRange.h_min, max: currentRange.h_max }) }}
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 form-size--bottom">
                    <div class="step-block--content-form-bottom">
                        <div class="step-block step-block--config step-block--config--size">
                            <div class="form-group">
                                <label>
                                    {{ $t('configurationName') }}
                                </label>
                                <input
                                        type="text"
                                        class="form-control"
                                        :value="form.name"
                                        :placeholder="$t('configurationNamePlaceholder')"
                                        @input="handleNameChange"
                                >
                            </div>
                        </div>
                        <div class="step-block step-block--value">
                            <div class="form-group quantity">
                                <label>
                                    {{ $t('quantity') }}
                                </label>
                                <input
                                        type="number"
                                        class="form-control"
                                        min="1"
                                        max="9"
                                        step="1"
                                        :value="form.count"
                                        @input="ev => handleCountChange(ev)"
                                >
                                <span class="units">
                  {{ $t('pieceUnit') }}
                </span>
                                <div class="quantity-nav">
                                    <div
                                            class="quantity-button quantity-up"
                                            @click="increaseQuantity"
                                    >
                                        <span class="icon icon-up-chevron"></span>
                                    </div>
                                    <div
                                            class="quantity-button quantity-down"
                                            @click="decreaseQuantity"
                                    >
                                        <span class="icon icon-down-chevron"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </step-section>
</template>

<script>
    import stepMixin from './stepMixin';

    export default {
        name: 'SizeAndQuantityStep',
        mixins: [stepMixin],
        props: {
            ranges: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                widthDirty: false,
            };
        },
        methods: {
            handleNameChange(ev) {
                this.updateFormField({
                    field: 'name',
                    value: ev.target.value,
                });
            },
            handleWidthBlur() {
                this.widthDirty = true;
            },
            handleWidthChange(ev) {
                this.widthDirty = true;
                this.updateFormField({
                    field: 'width',
                    value: ev.target.value,
                });
            },
            handleHeightChange(ev) {
                this.updateFormField({
                    field: 'height',
                    value: ev.target.value,
                });
            },
            handleCountChange(ev) {
                this.updateFormField({
                    field: 'count',
                    value: Number(ev.target.value),
                });
            },
            increaseQuantity() {
                const {form: {count = 1}} = this;

                this.updateFormField({
                    field: 'count',
                    value: count + 1,
                });
            },
            decreaseQuantity() {
                const {form: {count = 1}} = this;
                let newCount = count - 1;

                if (newCount < 1) {
                    newCount = 1;
                }

                this.updateFormField({
                    field: 'count',
                    value: newCount,
                });
            },
        },
        computed: {
            windowTypeImage() {
                const {form: {windowType = {}}} = this;
                return windowType.photo || null;
            },
            minWidth() {
                if (this.ranges.length === 0) {
                    return null;
                }


                return this.ranges
                    .map(range => range.w_min)
                    .reduce((a, b) => Math.min(a, b));
            },
            maxWidth() {
                if (this.ranges.length === 0) {
                    return null;
                }

                return this.ranges
                    .map(range => range.w_max)
                    .reduce((a, b) => Math.max(a, b));
            },
            currentRange() {
                const {ranges, form: {width}} = this;

                return ranges.find(range => {
                    return width >= range.w_min && width <= range.w_max;
                });
            },
            isWidthValid() {
                const {currentRange} = this;

                if (!currentRange) {
                    return false;
                }

                return true;
            },
            isHeightValid() {
                const {form: {height}, currentRange} = this;

                if (!currentRange) {
                    return false;
                }

                if (height < currentRange.h_min || height > currentRange.h_max) {
                    return false;
                }

                return true;
            },
        },
        watch: {
            currentRange(range) {
                const {updateFormField} = this;
                if (!range) {
                    updateFormField({
                        field: 'height',
                        value: null,
                    });
                }
            },
        },
    };
</script>
